import React from 'react';
import { Link } from 'react-router-dom';
import './NavBar.css';

const Navbar = () => {
  return (
    <nav className="navbar navbar-expand-lg navbar-dark">
      <div className="container-fluid">
        {/* Navbar Header */}
        <div className="navbar-header d-flex align-items-center">
          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarNav"
            aria-controls="navbarNav"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button>

          {/* Logo and Title */}
          <Link className="brand-name" to="/">
            Vanessa L
            <img
              src="/picz/icons/technology.png"
              alt="AI robot logo"
              className="brand-icon"
            />
            Developer
          </Link>
        </div>

        {/* Navigation Links */}
        <div className="collapse navbar-collapse" id="navbarNav">
          <ul className="navbar-nav w-100 justify-content-around text-center">
            {/* Internal link (same tab) */}
            <li className="nav-item">
              <Link className="nav-link nav-link-with-arrow" to="/">
                Home
              </Link>
            </li>

            <li className="nav-item">
              <Link className="nav-link nav-link-with-arrow" to="/contact">
                Contact
              </Link>
            </li>

            <li className="nav-item">
              <Link
                className="nav-link nav-link-with-arrow"
                to="/accessible-galapagos"
              >
                Accessibility Tools
              </Link>
            </li>

            <li className="nav-item">
              <Link className="nav-link nav-link-with-arrow" to="/poker">
                RetroSwitch
              </Link>
            </li>

            <li className="nav-item">
              <Link className="nav-link nav-link-with-arrow" to="/yaamava">
                Casino
              </Link>
            </li>

            <li className="nav-item">
              <Link className="nav-link nav-link-with-arrow" to="/lakersot">
                Lakers OT
              </Link>
            </li>
          
          {/* LinkedIn
            <li className="nav-item">
              <a
                className="nav-link nav-link-with-arrow"
                href="https://www.linkedin.com/in/hayashiv"
                target="_blank"
                rel="noopener noreferrer"
              >
                LinkedIn
              </a>
            </li>
           */}

          </ul>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
